export const calculateChatTurns = (turn: number) => ++turn;
